<template>
  <div class="publisher_container">
    <!-- 头部的Header -->
    <!-- 头部的Header -->
    <store-header
      :marketInfo="marketInfo"
      :marketClosed="true"
      :hasError="true"
      :isActive="false"
      :home="true"
      :isDetailPage="false"
    ></store-header>
    <!-- 间距 -->
    <div class="content">
      <div class="content_left">
        <el-avatar
          :size="120"
          v-if="appDetail.picURL"
          :src="appDetail.picURL"
        ></el-avatar>
        <el-avatar :size="120" v-else>
          {{ appDetail.realname }}
        </el-avatar>
      </div>
      <div class="content_right">
        <h2>{{ appDetail.realname || '' }}</h2>
        <p class="intro" v-if="appDetail.userDes">
          {{ appDetail.userDes || '' }}
        </p>
        <div class="intros" v-else>
          <p>暂无简介......</p>
        </div>
        <div class="emails">
          <img src="../../assets/images/emails.png" alt="" />
          <p>{{ appDetail.email || '' }}</p>
        </div>
      </div>
    </div>

    <!-- 列表区域 -->
    <div class="main_container">
      <div class="main_container_right">
        <div class="app_sort">
          <div class="sort_list">
            <span>排序:</span>
            <span class="sort_item">
              应用使用量
              <i
                :class="
                  arrowTimerConfig ? 'el-icon-arrow-down' : 'el-icon-arrow-up'
                "
              ></i>
            </span>
            <span class="sort_item">
              时间
              <i
                :class="
                  arrowUsedConfig ? 'el-icon-arrow-down' : 'el-icon-arrow-up'
                "
              ></i>
            </span>
            <div class="sort_type">
              <span>排序方式:</span>
              <div @click="handleChangeType('one')">
                <img
                  :src="sortType1"
                  onload="SVGInject(this)"
                  class="typeSvg"
                  ref="typeOne"
                />
              </div>
              <div @click="handleChangeType('three')">
                <img
                  :src="sortType2"
                  onload="SVGInject(this)"
                  class="typeSvg"
                  ref="typeThree"
                />
              </div>
            </div>
          </div>
          <div class="app_total">共 {{ pageTotal }} 条</div>
        </div>
        <div
          v-if="appLoading"
          style="
            height: 100%;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          <a-spin />
        </div>
        <div v-else class="app_box">
          <!-- 一条 -->
          <template v-if="appList.length && !sortTypeStatus">
            <div class="app_item" v-for="item in appList" :key="item.appKeyID">
              <!-- 左侧的icon -->
              <div class="app_icon">
                <div
                  :style="{
                    backgroundImage: `url(${item.logo || appLogoDef})`
                  }"
                ></div>
                <img :src="item.logo || appLogoDef" />
              </div>
              <!-- 右侧应用描述 -->
              <div class="app_detail">
                <!-- 应用名称 -->
                <div class="app_name">
                  <span @click="handleViewDetail(item)">{{ item.name }}</span>
                </div>
                <!-- 版本 -->
                <div
                  class="app_version"
                  v-if="item.versions && item.versions.length > 0"
                >
                  版本: {{ item.versions[item.versions.length - 1].appVersion }}
                </div>
                <!-- 访问浏览数 -->
                <div class="app_data">
                  <!-- 安装量 -->
                  <div class="visit">
                    <img :src="appVisit" alt="应用访问数" />
                    <span>{{ item.showCount }}</span>
                  </div>
                  <!-- 浏览量 -->
                  <div class="install">
                    <img :src="appInstall" alt="应用安装数" />
                    <span>{{ item.installCount }}</span>
                  </div>
                </div>
                <!-- 应用的描述 -->
                <div class="app_desc">
                  <p>{{ item.desc }}</p>
                </div>
                <!-- 分割线 -->
                <div class="app_line"></div>
                <!-- 标签 -->
                <div class="tags_box">
                  <div
                    class="tag_item ovellipsis"
                    v-for="(tag, idx) in item.tags"
                    :key="idx"
                  >
                    {{ tag }}
                  </div>
                </div>
                <!-- 查看更多 -->
                <div class="more">
                  <el-button size="mini" @click="handleViewDetail(item)">
                    查看详情
                  </el-button>
                </div>
              </div>
            </div>
          </template>
          <!-- 一行展示3条数据 -->

          <template v-if="appList.length && sortTypeStatus">
            <div class="card" v-for="item in appList" :key="item.appKeyID">
              <div class="app_icon_three">
                <img
                  v-if="item.templateType == 'helm'"
                  class="helmIcon"
                  src="../../assets/images/helmIcon.svg"
                  alt=""
                />
                <div
                  :style="{
                    backgroundImage: `url(${item.logo || appLogoDef})`
                  }"
                ></div>
                <img class="logoIcon" :src="item.logo || appLogoDef" />
              </div>
              <!-- 分割线 -->
              <div class="app_line_three"></div>
              <!-- 名称 -->
              <div class="app_name_three">
                <span @click="handleViewDetail(item)">{{ item.name }}</span>
              </div>
              <!-- 版本 -->
              <div
                class="app_version_three"
                v-if="item.versions && item.versions.length > 0"
              >
                版本:
                {{ item.versions[item.versions.length - 1].appVersion }}
              </div>
              <div class="app_version_three" v-else></div>
              <!-- 描述 -->
              <div class="app_desc_three">
                <p>{{ item.desc }}</p>
              </div>
              <!-- 分割线 -->
              <div class="app_line_three"></div>
              <!-- 浏览访问量 -->
              <div class="app_data_three">
                <!-- 安装量 -->
                <div class="visit_three">
                  <img :src="appVisit" alt="应用访问数" />
                  <span>{{ item.showCount }}</span>
                </div>
                <!-- 浏览量 -->
                <div class="install_three">
                  <img :src="appInstall" alt="应用安装数" />
                  <span>{{ item.installCount }}</span>
                </div>
              </div>
              <!-- 分割线 -->
              <div class="app_line_three"></div>
              <!-- 标签 -->
              <div class="tags_box_three">
                <div
                  class="tag_item_three"
                  v-for="(tag, idx) in item.tags"
                  :key="idx"
                >
                  {{ tag }}
                </div>
              </div>
              <div class="timeUpdate">
                {{ timmer(item.updateTime) }}
              </div>
              <button class="card-button" @click="handleViewDetail(item)">
                查看详情
              </button>
            </div>
          </template>
        </div>
        <!-- 分页 -->
        <el-pagination
          style="margin-top: 12px"
          class="app_pagination"
          layout="prev, pager, next"
          :page-size="pageSize"
          :total="pageTotal"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 底部 -->
    <Footer :isTheme="true"></Footer>
  </div>
</template>
<script>
import { getMarketBaseInfoApi } from '@/api/appStore';
import { getSelfSortAppList, getAuthorInfo } from '@/api/user';
import appInstall from '@/assets/images/app_install.svg';
import appVisit from '@/assets/images/app_visit.svg';
import bgImg from '@/assets/images/bg.jpg';
import sortType2 from '@/assets/images/sort-type-one.svg';
import sortType1 from '@/assets/images/sort-type-three.svg';
import Header from '@/components/Header/store';
import SVGInject from '@iconfu/svg-inject';
import Footer from '@/components/Footer/index';
import { fetchdayTimes } from '@/utils/timmer';
export default {
  name: 'Publish',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      appInstall,
      appVisit,
      marketInfo: {},
      bgImg,
      appList: [],
      appLogoDef: require('../../assets/images/app_icon.png'),
      appLoading: true,
      page: 1,
      pageSize: 16,
      pageTotal: '',
      isTheme: true,
      userInfo: {},
      appDetail: {},
      SVGInject,
      sortType1,
      sortType2,
      arrowTimerConfig: true, // 排序时间箭头的状态,
      arrowUsedConfig: true, // 排序使用量箭头的状态
      sortTypeStatus: true
    };
  },
  props: {},
  computed: {
    defaultMarketDomain() {
      return this.$store.state.user.platformInfo.defaultMarketDomain;
    }
  },
  watch: {
    $route: {
      immediate: true,
      deep: true
    },
    // 按时间排序
    arrowTimerConfig: function(newVal, oldVal) {
      if (this.indexConfig === 0) {
        if (newVal) {
          this.handleLoadAppList();
        } else {
          this.handleLoadAppList(0, '0');
        }
      }
    },
    // 按使用量排序
    arrowUsedConfig: function(newVal, oldVal) {
      if (this.indexConfig === 1) {
        if (newVal) {
          this.handleLoadAppList(1);
        } else {
          this.handleLoadAppList(1, false, '0');
        }
      }
    }
  },
  mounted() {
    // 页面加载的处理
    const that = this;
    const appSorts = document.getElementsByClassName('sort_item');
    const sortType = document.getElementsByClassName('typeSvg');
    sortType[0].classList.add('activeType');
    for (let i = 0; i < appSorts.length; i++) {
      // eslint-disable-next-line space-before-function-paren
      appSorts[i].onclick = function () {
        that.indexConfig = i;
        for (let j = 0; j < appSorts.length; j++) {
          appSorts[j].classList.remove('active');
        }
        if (i === 0) {
          that.arrowTimerConfig = !that.arrowTimerConfig;
        } else {
          that.arrowUsedConfig = !that.arrowUsedConfig;
        }
        this.classList.add('active');
      };
    }
    const {
      params: { searchQuery }
    } = this.$route;
    searchQuery && this.queryChange(searchQuery, 'detail');
  },
  created() {
    this.handleLoadMartInfo();
    this.handleLoadAppList();
    this.handleAuthorInfo();
  },

  methods: {
    // 切换应用列表布局
    handleChangeType(type) {
      const sortType = document.getElementsByClassName('typeSvg');
      if (type === 'one') {
        sortType[0].classList.add('activeType');
        sortType[1].classList.remove('activeType');
        this.sortTypeStatus = true;
        this.handleLoadAppList();
      } else {
        sortType[1].classList.add('activeType');
        sortType[0].classList.remove('activeType');
        this.sortTypeStatus = false;
        this.handleLoadAppList();
      }
    },
    // 获取商店详情
    handleLoadMartInfo() {
      // const marketId = this.$route.params.marketID;
      getMarketBaseInfoApi({ marketId: '859a51f9bb3b48b5bfd222e3bef56425' })
        .then((res) => {
          window.sessionStorage.setItem(
            'storeDomain',
            JSON.stringify(res.domain)
          );
          this.marketInfo = res;
        });
    },
    // 获取作者信息
    handleAuthorInfo() {
      var params = {
        marketID: '859a51f9bb3b48b5bfd222e3bef56425',
        userID: this.$route.params.publisherID
      };
      getAuthorInfo(params).then((res) => {
        this.appDetail = res;
      });
    },
    // 获取应用列表
    handleLoadAppList(type = 0, timer = '1', used = '1') {
      if (type === 0) {
        var params = {
          marketID: '859a51f9bb3b48b5bfd222e3bef56425',
          userID: this.$route.params.publisherID,
          page: this.page,
          pageSize: this.pageSize,
          usedSort: timer === '1' ? '1' : timer
        };
      } else {
        // eslint-disable-next-line no-redeclare
        var params = {
          marketID: '859a51f9bb3b48b5bfd222e3bef56425',
          userID: this.$route.params.publisherID,
          page: this.page,
          pageSize: this.pageSize,
          timeSort: used === '1' ? '1' : used
        };
      }
      getSelfSortAppList(params)
        .then((res) => {
          this.appList = res.apps;
          this.pageTotal = res.total;
          this.appLoading = false;
        })
        .catch(() => {
          this.appLoading = false;
        });
    },
    // 分页
    handleCurrentChange(page) {
      this.page = page;
      this.handleLoadAppList();
    },
    // 应用详情
    handleViewDetail(item) {
      //   跳转详情页
      this.$router.push({ path: `/marketplace/apps/${item.appKeyID}` });
    },
    timmer(date) {
      return fetchdayTimes(date);
    }
  }
};
</script>

<style scoped lang="scss">
@import 'src/styles/appStore.scss';
.card {
  width: 24%;
  height: 330px;
  border-radius: 5px;
  background: #f5f5f5;
  position: relative;
  //  padding: 1.8rem;
  border: 1px solid #c3c6ce;
  transition: 0.5s ease-out;
  overflow: visible;
  margin: 0 5px 30px;
}

.card-details {
  color: black;
  height: 100%;
  gap: 0.5em;
  display: grid;
  place-content: center;
}

.card-button {
  transform: translate(-50%, 125%);
  width: 60%;
  border-radius: 10px;
  border: none;
  background-color: #008bf8;
  color: #fff;
  font-size: 1rem;
  padding: 0.5rem 1rem;
  position: absolute;
  left: 50%;
  bottom: 0;
  opacity: 0;
  transition: 0.3s ease-out;
}

.text-body {
  color: rgb(134, 134, 134);
}

/*Text*/
.text-title {
  font-size: 1.5em;
  font-weight: bold;
}

/*Hover*/
.card:hover {
  border-color: #008bf8;
  box-shadow: 0 4px 18px 0 rgba(0, 0, 0, 0.25);
}

.card:hover .card-button {
  transform: translate(-50%, 50%);
  opacity: 1;
}
.publisher_container {
  background: #f7f7f9;
  //   height: 100vh;
}
.content {
  width: 90%;
  margin: 40px auto;
  background-color: #ffffff;
  padding: 24px 50px;
  // box-shadow: 0 5px 10px ;
  border: 1px solid #ececec;
  display: flex;
  flex-flow: row;
  border-radius: 5px;
  ::v-deep .content_left {
    width: 20%;
    text-align: center;
    span {
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .content_right {
    width: 80%;
    h2 {
      font-size: 20px;
      font-weight: bolder;
    }
    .intro {
      min-height: 40px;
      font-size: 14px;
      color: #5f6367;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
      overflow: hidden;
    }
    .intros {
      min-height: 40px;
      font-size: 14px;
      color: #5f6367;
      display: flex;
      flex-flow: row;
      img {
        width: 20px;
        height: 20px;
        margin-right: 4px;
      }
      p {
        color: #777777;
      }
    }
    .emails {
      display: flex;
      flex-flow: row;
      img {
        width: 20px;
        height: 20px;
        margin-right: 4px;
      }
      p {
        color: #777777;
        font-size: 12px;
      }
    }
  }
}
::v-deep .app_pagination {
  text-align: right;
  margin-top: 20px;
  .btn-prev,
  .btn-next,
  .el-pager li {
    width: 30px;
    height: 30px;
    border: 1px solid #d9d9d9;
    margin-right: 4px;
    padding: 0;
    min-width: 30px;
    line-height: 30px;
    color: rgba(0, 0, 0, 0.65);
  }
  .el-pager ul {
    width: 0;
  }
  .el-pager li.active {
    background-color: #1890ff;
    color: #fff;
  }
}
.main_container {
  width: 90%;
  margin: 0 auto;
  min-height: 800px;
  display: flex;
  .main_container_left {
    width: 260px;
    height: calc(100vh - 340px);
    padding: 35px 0 30px 15px;
    margin-right: 20px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
    background-color: #fff;
    .user_info {
      margin-bottom: 12px;
      & > span:nth-child(1) {
        font-weight: bold;
        margin-right: 6px;
        width: 36px;
      }
      & > span {
        word-break: normal;
        white-space: pre-warp;
        word-wrap: break-word;
      }
    }
  }
  .main_container_right {
    flex: 1;
    // box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
    // 排序
    .app_sort {
      width: 100%;
      height: 42px;
      background-color: #ffffff;
      border: 1px solid #ececec;
      margin-bottom: 12px;
      display: flex;
      padding: 0px 16px;
      align-items: center;
      justify-content: space-between;
      border-radius: 5px;
      .sort_list {
        display: flex;
        & > span {
          margin-right: 16px;
          cursor: pointer;
        }
        & > span:nth-child(1) {
          margin-right: 0px;
          width: 36px;
          cursor: default;
        }
        .sort_type {
          display: flex;
          align-items: center;
          span {
            width: 64px;
          }
          & > div {
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .typeSvg {
            margin-right: 5px;
            cursor: pointer;
          }
        }
      }
    }
    .listTitle {
      width: 100%;
      padding: 8px 16px;
      font-size: 16px;
      font-weight: bolder;
      background-color: #fff;
    }
  }
}
.app_box {
  display: flex;
  flex-wrap: wrap;
  margin-left: 0.5%;
  // 一行
  .app_item {
    display: flex;
    position: relative;
    align-items: center;
    width: 100%;
    margin-bottom: 12px;
    background-color: #ffffff;
    border-radius: 5px;
    border: 1px solid #c3c6ce;
    &:hover .app_icon > div {
      transition: 0.3s ease-in;
      filter: blur(60px);
    }
    p {
      margin-bottom: 0px !important;
    }
    // 左侧图标
    .app_icon {
      height: 100%;
      width: 160px;
      margin-right: 24px;
      padding: 0 30px 30px;
      position: relative;
      overflow: hidden;
      img {
        padding-top: 60px;
        width: 100px;
        height: 160px;
        box-sizing: border-box;
      }
      div {
        position: absolute;
        height: 100%;
        width: 100px;
        background-size: cover;
        filter: blur(140px);
        background-position: 10% 50%;
        overflow: hidden;
      }
    }
    // 右侧应用描述
    .app_detail {
      padding: 30px 10px 10px;
      // 名称
      .app_name {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 12px;
        span {
          cursor: pointer;
        }
      }
      .app_name > span:hover {
        color: #456fe2 !important;
      }
      // 版本
      .app_version {
        color: rgba(84, 88, 90, 0.7);
        margin-bottom: 12px;
      }
      // 访问数  浏览数
      .app_data {
        display: flex;
        margin-bottom: 12px;
        span {
          color: rgba(84, 88, 90, 0.7);
          font-size: 12px;
        }
        .visit {
          margin-right: 12px;
        }
      }
      // 描述
      .app_desc {
        font-size: 12px;
        color: rgba(84, 88, 90, 0.7);
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        width: 650px;
        p {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }
      .tags_box {
        display: flex;
        flex-wrap: wrap;
        overflow-x: auto;
        height: 32px;
        .tag_item {
          max-width: 80px;
          color: rgba(84, 88, 90, 0.7);
          height: 22px;
          margin: 0 6px 6px 0;
          background: #f2f4f6;
          border: 1px solid #dde1e6;
          border-radius: 3px;
          padding: 0 8px;
          line-height: 20px;
        }
      }
      // 查看更多
      .more {
        position: absolute;
        right: 32px;
        top: 50%;
        transform: translateY(-50%);
        span {
          color: #fff;
        }
        .el-button {
          border: 1px solid #456fe2;
          border-radius: 5px;
          background-color: #456fe2;
          color: #fff;
        }
      }
    }
    &:hover {
      box-shadow: 0px 0px 2px 2px rgba(0, 0, 0, 0.1);
      border: 1px solid #456fe2;
    }
    .gray_block {
      position: absolute;
      right: 0;
      top: 0;
      width: 15px;
      height: 15px;
      background-color: #d8d8d8;
    }
  }
  // 三行
  .app_item_three,
  .card:hover .app_icon_three > div {
    transition: 0.3s ease-in;
    filter: blur(40px);
  }
  .card,
  .app_item_three {
    width: 24%;
    margin-bottom: 30px;
    background-color: #ffffff;
    padding-bottom: 60px;
    position: relative;
    // border: 1px solid #e8e8e8;
    border-radius: 5px;
    p {
      margin-bottom: 0px !important;
    }
    // 图标
    .app_icon_three {
      height: 80px;
      width: 100%;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      position: relative;
      overflow: hidden;
      div {
        position: absolute;
        width: 100%;
        height: 80px;
        background-size: cover;
        filter: blur(150px);
        background-position: 50% 50%;
      }
      img {
        margin: 10px 40%;
        width: 60px;
      }
    }
    // 分割线
    .app_line_three {
      height: 1px;
      background-color: #faf4f4;
    }
    // 名称
    .app_name_three {
      padding: 10px 16px;
      font-size: 16px;
      font-weight: bold;
      color: #000;
      text-align: center;
      span {
        cursor: pointer;
      }
    }
    // 版本
    .app_version_three {
      width: 100%;
      height: 24px;
      color: rgba(84, 88, 90, 0.7);
      padding: 0px 16px 5px 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: center;
    }
    // 描述
    .app_desc_three {
      font-size: 14px;
      padding: 0px 16px;
      margin-bottom: 15px;
      max-height: 40px;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: center;
      min-height: 36px;
    }
    // 浏览访问数
    .app_data_three {
      display: flex;
      padding: 10px 16px;
      text-align: center;
      justify-content: space-around;
      span {
        color: rgba(84, 88, 90, 0.7);
        font-size: 12px;
      }
      .visit_three {
        margin-right: 12px;
      }
    }
    // 标签
    .tags_box_three {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      // overflow-x: auto;
      padding: 12px 16px;
      height: 32px;
      .tag_item_three {
        max-width: 80px;
        color: rgba(84, 88, 90, 0.7);
        height: 22px;
        margin: 0 6px 6px 0;
        background: #f2f4f6;
        border: 1px solid #dde1e6;
        border-radius: 3px;
        padding: 0 8px;
        line-height: 20px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
    .more_three {
      position: absolute;
      width: 100%;
      left: 50%;
      transform: translate(-50%, -50%);
      bottom: 10px;
      text-align: center;

      span {
        color: #456fe2;
        cursor: pointer;
      }
    }
    .app_name_three > span:hover {
      color: #456fe2;
    }
    &:hover {
      transition: 0.3s ease-in;
      box-shadow: 2px 4px 10px 0px rgba(0, 0, 0, 0.1);
    }
  }
  // & .app_item_three:nth-of-type(3n + 1) {
  //   margin-right: 0px !important;
  // }
}
.timeUpdate {
  position: absolute;
  right: 5%;
  bottom: 2%;
  font-size: 12px;
  color: rgba(84, 88, 90, 0.7);
}
</style>



// WEBPACK FOOTER //
// src/views/Publisher/index.vue